// extracted by mini-css-extract-plugin
export default {"wrapper":"personContactSet_wrapper__3Ca+p","iconLink":"personContactSet_iconLink__zIKJB"};